
























































/* eslint-disable camelcase */
import { debounce } from '~/utils/function'
import CPostcodeAutocomplete from '~/components/shared/configurable/form/autocomplete/CPostcodeAutocomplete.vue'
import { DEBOUNCE_EXTRA_SLOW } from '~/constants/debounce'
import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { computeFieldState } from '~/utils/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import { CountryId } from '~/models/location/country'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export interface Country {
  code: string
  id: number
  name: string
  postcode_validator: string
  required: object
}
export default defineComponent({
  components: {
    CPostcodeAutocomplete,
    FieldError
  },
  props: formFieldProps,
  setup(props) {
    const country = ref(null)
    const postcode = ref(null)
    const address = ref(null)

    const countryError = ref(null)
    const postcodeError = ref(null)
    const addressError = ref(null)

    const { specs, name } = toRefs(props)

    const getCountry: Country = id =>
      specs.value.countries.find(country => country.id === id)

    function onValue(v: Ref<any>) {
      if (v.value?.country?.id) {
        country.value = getCountry(v.value.country.id)
      } else {
        country.value = getCountry(specs.value.default_country)
      }

      if (v.value?.postcode?.name) {
        if (v.value.postcode.id) {
          postcode.value = v.value.postcode
          address.value = null
        } else {
          address.value = v.value.postcode.name
          postcode.value = null
        }
      } else {
        postcode.value = null
      }
    }

    const { valueChanged, error } = useClassifiedForm(props, { onValue })
    const formValidationBuilder = useDep(FormValidationBuilder)

    const postcodeIsValid = computed(() =>
      computeFieldState(postcodeError.value)
    )
    const addressIsValid = computed(() => computeFieldState(addressError.value))
    const countries: Country[] = computed(() => specs.value.countries)
    const greeceIsSelected = computed(
      () => country.value.id === CountryId.GREECE
    )
    const cyprusIsSelected = computed(
      () => country.value.id === CountryId.CYPRUS
    )
    const useGoogleAutocomplete = computed(
      () => !greeceIsSelected.value && !cyprusIsSelected.value
    )

    const someValueChanged = () => {
      const getCountry = () => {
        const countryId = country.value?.id
        if (countryId) {
          return { id: country.value.id }
        }
        return null
      }
      const getPostcode = () => {
        if (useGoogleAutocomplete.value) {
          return { name: address.value }
        } else if (postcode.value?.name) {
          return postcode.value
        }
        return null
      }
      valueChanged(name.value, {
        country: getCountry(),
        postcode: getPostcode()
      })
    }
    const handlePostcodeInput = (text: string) => {
      if (text.length === 0) {
        postcode.value = null
      }
      someValueChanged()
    }
    const handlePostcodeChange = pc => {
      postcode.value = pc
      someValueChanged()
    }

    const handleAddressInput = debounce((text: string) => {
      formValidationBuilder
        .new(addressError)
        .required(specs.value.required, text)
        .postcodeIsValid(
          text,
          country.value && new RegExp(country.value.postcode_validator)
        )
        .validate()

      someValueChanged()
    }, DEBOUNCE_EXTRA_SLOW)

    return {
      country,
      countryError,
      postcode,
      postcodeError,
      address,
      addressError,
      postcodeIsValid,
      addressIsValid,
      countries,
      useGoogleAutocomplete,
      getCountry,
      handlePostcodeInput,
      handlePostcodeChange,
      someValueChanged,
      handleAddressInput,
      error
    }
  }
})
